
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.431 10.285A6.553 6.553 0 0012 5a6.56 6.56 0 00-5.819 3.535A5.244 5.244 0 001.5 13.75 5.254 5.254 0 006.75 19h11.375a4.377 4.377 0 004.375-4.375c0-2.31-1.794-4.183-4.069-4.34zm-.306 6.965H6.75a3.499 3.499 0 01-3.5-3.5c0-1.934 1.566-3.5 3.5-3.5h.621A4.815 4.815 0 0112 6.75a4.81 4.81 0 014.813 4.812V12h1.312a2.62 2.62 0 012.625 2.625 2.621 2.621 0 01-2.625 2.625z","fill-rule":"nonzero"}})])
          )
        }
      }
    